// extracted by mini-css-extract-plugin
export var cardHeader = "_he-1";
export var contentCard = "_he-0";
export var headerActions = "_he-3";
export var reorderHandle = "_he-5";
export var titleArea = "_he-2";
export var titleAreaWithHandle = "_he-4";